import React, { createContext, useContext, useState, useCallback, useEffect } from 'react';
import { adminVerify } from '../data/api';

const AdminContext = createContext(null);

export const AdminProvider = ({ children }) => {
  const [token, setToken] = useState(() => localStorage.getItem('starkke_admin_token') || '');
  const [checking, setChecking] = useState(!!token);

  useEffect(() => {
    if (!token) {
      setChecking(false);
      return;
    }
    adminVerify(token)
      .catch(() => {
        localStorage.removeItem('starkke_admin_token');
        setToken('');
      })
      .finally(() => setChecking(false));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const login = useCallback((tok) => {
    localStorage.setItem('starkke_admin_token', tok);
    setToken(tok);
  }, []);

  const logout = useCallback(() => {
    localStorage.removeItem('starkke_admin_token');
    setToken('');
  }, []);

  return (
    <AdminContext.Provider value={{ token, isAuth: !!token, checking, login, logout }}>
      {children}
    </AdminContext.Provider>
  );
};

export const useAdmin = () => {
  const ctx = useContext(AdminContext);
  if (!ctx) throw new Error('useAdmin must be used within AdminProvider');
  return ctx;
};
